{
  "index": {
    "title": "Preferences Templates",
    "create": "Create Template",
    "empty_list_title": "No Preference Templates",
    "empty_list_description": "Click the create button to create your first preference template.",
    "edit": "Edit Template"
  },
  "new": {
    "title": "Create New Template",
    "save": "Create Template",
    "form": {
      "name": "Name"
    }
  },
  "timetable": {
    "events.short_title": "Prf{{preference}} Pri{{priority}}",
    "events.short_title_all_subjects": "Prf{{preference}} Pri{{priority}} {{subject_code}}",
    "schedule": {
      "conflicts": "This preference cannot conflict with another subject",
      "custom_class_name": "Class: {{name}}",
      "educator_name": "Educator: {{name}}",
      "duration": "{{duration}} minutes",
      "fixed": "Day {{day}} {{start}} - {{end}}"
    }
  },
  "edit": {
    "title": "Edit Preference Template",
    "class": {
      "add": "Add Class",
      "add_description": "Choose one class to add as a preference.",
      "preference": {
        "label": "Preference {{rank}}",
        "ranking": {
          "increase": "Increase Rank",
          "decrease": "Decrease Rank",
          "no_increase": "Cannot Increase Rank - already at maximum rank",
          "no_decrease": "Cannot Decrease Rank - already at minimum rank"
        },
        "schedule": {
          "priorities_list_label": "Priorities",
          "priority": "Priority: {{priority}}",
          "fixed": "Day {{day}} {{start}} - {{end}}",
          "select_priority": {
            "label": "Select Priorities",
            "description": "Choose a priority to add a preference to.",
            "save_one": "Select Priority (1)",
            "save_other": "Select Priorities ({{count}})"
          }
        }
      }
    }
  },
  "applications": {
    "new": {
      "title": "Select Students to Apply Template To",
      "description": "This will apply the template's subject preferences to the selected students, replacing any existing preferences they may have for those subjects.",
      "apply": "Apply Template",
      "selected.label": "Selected Students",
      "combobox.select": "Select Students"
    }
  }
}
